export const cpfValidation = (value = '') => value.length === 11;

export const passwordValidation = (value = '') => value.length === 6;

export const creditCardValidation = (value = '') => value.length === 16;

export const cvvValidation = (value = '') => value.length === 3;

export const expirationDateValidation = (value = '') => value.length === 4;
